import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Check, CircleDot, ChevronRight } from "lucide-react"
import JSONPretty from 'react-json-pretty';
import _ from "lodash"
import { cn, queryTools } from "lib/utils"
import { UnitTitleBlock } from "lib/components"
import { migrateBasics, migrateConditional, compellingEvidence } from "./migration/ops"
import { fetchpaths } from "./data/fetchpaths"

import { migrate_dispute } from "lib/utils";

import { apidata } from "./migration/data/apidata"




export default function MigrateDisputes(){
  const navigate = useNavigate()
  const env = (process.env.NODE_ENV === "production") ? "prod" : "dev"

  // Fetch the old templates from the tb2 prod server always
  const fetchTemplatesFromTBv2 = async() => {
    const headers = { "Content-Type": "application/json", "apikey": "mm33dr$reH6F4" }
    let payload
    const fetchPath = fetchpaths.tb2.prod + "/migration/template"
    try {
      const response = await fetch(fetchPath, { headers })
      console.log(response)
      const data = await response.json()
      return data.payload
    } catch(err){
      console.error(err)
    }
  }

  const { data:_Disputes } = queryTools.resource.parseQueryForApi("dispute.findAll", {}, { enabled: true })
  // const { data:_Migrations } = queryTools.resource.parseQueryForApi("migration.findAll", {}, { enabled: true })
  
  const [ templatesToMigrate, setTemplatesToMigrate ] = useState<any>()
  const [ chosenTemplate, setChosenTemplate ] = useState<any>()
  const [ migratedTemplate, setMigratedTemplate ] = useState<any>()

  const saveFn = queryTools.resource.save(["dispute"])

  const getTemplatesToMigrate = async() => {
    try {
      const oldTemplates = await fetchTemplatesFromTBv2()
      setTemplatesToMigrate(oldTemplates)
    } catch(err){
      console.error(err)
      setTemplatesToMigrate([])
    }
  }

  async function handleTemplateSave(data:any){
    saveFn.mutate({ resource: "dispute", data: {...data, _id: undefined} })
    navigate("/dispute")
  }

  const migrateTemplateToDispute = (original:any) => {
    
    const opening_statements = migrateConditional(original) // original.Segments.map( (seg:any) =>  migrateSegment(seg) )
    const compelling_evidence = compellingEvidence

    let newTmpl:any = migrate_dispute(original, opening_statements, compelling_evidence)
    console.log(newTmpl)
    setMigratedTemplate(newTmpl)
  }

  useEffect(() => {
    if( !templatesToMigrate ){
      getTemplatesToMigrate()
    }
  },[templatesToMigrate])

  if(!templatesToMigrate ) return <div className="w-full pt-6">Loading...</div>
  return (
    <div className={cn("w-full pt-6")}>
      <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="Template Migrator" />
      <div className="w-full flex gap-10">

        {/* old templates here  */}
        <div className="w-[27%] flex flex-col">
          <h3 className="text-lg font-bold pb-1 mb-3 border-b border-solid border-slate-700">Choose a Template</h3>
          <div className="w-full flex flex-col border border-slate-700 h-[50rem] overflow-auto scrollbar">
            { templatesToMigrate.filter((tmpl:any) => tmpl.Title.length > 0).sort((a:any, b:any) => a.Title > b.Title ? 1 : -1).map( (template:any) => (
              <div 
                key={template._id} 
                onClick={() => setChosenTemplate(template)}
                className={cn(
                  "w-full px-3 py-2 flex justify-start items-center bg-transparent hover:bg-teal-800 cursor-pointer text-neutral-200 text-sm",
                  chosenTemplate?._id === template._id && "bg-teal-900 hover:bg-teal-900"
                )}
              >
                { template.Title }
              </div>
            ))}
          </div>
        </div>

        <div className="w-[1%] flex h-[50rem] justify-center items-center">
          <button 
            onClick={() => migrateTemplateToDispute(chosenTemplate)}
            className={cn(
              "w-full px-6 h-8 bg-teal-800 flex justify-center items-center text-neutral-200 rounded-full",
              !chosenTemplate && "opacity-30 cursor-not-allowed"
            )}
            disabled={!chosenTemplate}
          >
            <span> GO </span>
          </button>
        </div>

        <div className="w-[27%] flex flex-col">
          <h3 className="text-lg font-bold pb-1 mb-3 border-b border-solid border-slate-700">Already Migrated</h3>
          <div className="w-full flex flex-col border border-slate-700 h-[50rem] overflow-auto scrollbar">
            { _Disputes?.map( (template:any) => (
              <div 
                key={template._id} 
                className="w-full px-3 py-2 flex justify-start items-center bg-transparent hover:bg-teal-800 cursor-pointer text-neutral-200 text-sm"
              >
                { template.title }  ({template.Id})
              </div>
            ))}
          </div>
        </div>

        {/* code comparison here  */}
        <div className="w-[45%] flex flex-col items-start justify-start"> 
          <div className="w-full flex justify-between items-center pb-1 mb-3 border-b border-solid border-slate-700">
            <h3 className="h-full flex items-center text-lg font-bold">
              Original Version 
            </h3>
            {/* <div className="h-full flex items-center" onClick={() => migrateTemplateToDispute(chosenTemplate)}>migrate</div> */}
          </div>
          <div className="w-full h-[20rem] border border-solid border-slate-700 h-80 p-3 max-h-[40rem] overflow-y-auto overflow-x-hidden font-mono">
            <JSONPretty id="json-pretty" data={chosenTemplate || {} }></JSONPretty>
          </div>

          <h3 className="w-full text-lg font-bold pb-1 mt-6 mb-3 border-b border-solid border-slate-700">
            Migrated Dispute 
          </h3>
          <div className="w-full h-[20rem] border border-solid border-slate-700 h-80 p-3 max-h-[40rem] overflow-y-auto overflow-x-hidden font-mono">
            <JSONPretty id="json-pretty" data={migratedTemplate || {} }></JSONPretty>
          </div>
          
          <p 
            className="mt-8 w-full bg-teal-800 border border-solid border-teal-700 p-4 flex justify-center items-center" 
            onClick={() => handleTemplateSave(migratedTemplate)}
          >
            Add Template To New Collection
          </p>

        </div>

      </div>
    </div>
  )
}